export default {"src":"/_next/static/media/edit.5f033fbe.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};